import PageHeader from '../components/layout/PageHeader';
import SplitSection from '../components/layout/SplitSection';
import usePageTitle from '../hooks/usePageTitle';

export default function Products() {
  usePageTitle('Our Products');

  return (
    <>
      <PageHeader eyebrow="Pet store" title="Our Products" />

      <SplitSection
        id="products"
        image="images/product/1.png"
        imageAlt="A selection of veterinary products stocked at Paw Global Veterinary"
        aspectRatio="4 / 3"
        mediaFit="contain"
      >
        <p>
          At Paw Global Veterinary, we believe that trusted care begins with trusted products.
          That’s why we source our veterinary offerings globally—from Korea, Canada, Indonesia,
          Taiwan, Thailand, Denmark, the United States, and Japan—ensuring that every
          product we deliver reflects the highest standards of quality and efficacy.
        </p>
      </SplitSection>
    </>
  );
}
